import { Components, inputLabelClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiTextField to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/text-field/#css
 */
export const MuiTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'medium',
  },
  styleOverrides: {
    root: {
      [`& label`]: {
        top: '-10px',
        [`&.${inputLabelClasses.sizeSmall}`]: {
          top: '-7px',
        },
        [`&.${inputLabelClasses.shrink}`]: {
          top: 0,
        },
      },
    },
  },
};
